import _ from 'lodash'
import { FTProcess } from '@/models/FTProcess';
import { initProcess, ProcessConfig, ConversionResults, ParsedVariables } from './index';
import { FTProcessRow } from '@/models/FTProcessRow';
import { ConversionDetails } from '@/models/ConversionDetails';
import { compareStringIgnoreCase } from '@/utils';

export function loadConfig({ processRow }: ParsedVariables): ProcessConfig {
  return {
    inputs: {
      goods: [
        {
          goodsType: 'product',
          multiple: true,
          addMultipleButtonText: 'add more inputs',
          params: [
            {
              name: 'Quantity',
              type: 'quantity',
              value: 'quantity',
              enableConvertFnIf: compareStringIgnoreCase(_.get(processRow, 'goodsObject.rawMaterialUnit', ''),'SQM'),
              disabled: false
            },
            {
              name: 'No Of Pieces',
              type: 'label',
              value: _.get(processRow, 'noOfPieces', ''),
              disabled: true
            }
          ]
        },
        {
          goodsType: 'packing-material',
          multiple: true,
          addMultipleButtonText: 'add more packing Inputs',
          hideRemoveInputIcon: true,
          optionalIf: _.get(processRow, 'ftProcess.ftFactoryTicket.order.product.productLine') === 'Pressure Sensitive Label' && _.get(processRow, 'packingMode.unit1') === 'pcs',
          params: [
            {
              name: 'No Of Pieces',
              type: 'text',
              value: 'noOfPieces',
              unit: 'Pcs',
              minWidth: '100px',
              disabled: false
            },
            {
              name: 'Quantity',
              type: 'label',
              value: _.get(processRow, 'quantity', ''),
              unit: 'KG',
              minWidth: '100px',
              disabled: true
            },
            {
              name: 'Size',
              type: 'label',
              value: `${_.get(processRow, 'goodsObject.dimensions.width', '')} * ${_.get(processRow, 'goodsObject.dimensions.length', '')}`,
              minWidth: '70px',
              disablePrint: true,
              disabled: true
            },
            {
              name: 'Packing Mode',
              type: 'label',
              value: `${_.get(processRow, 'packingMode.quantity', '')} ${_.get(processRow, 'packingMode.unit1', '')}/${_.get(processRow, 'packingMode.unit2', '')}`,
              minWidth: '125px',
              disablePrint: true,
              disabled: true
            }
          ]
        }
      ]
    },
    outputs: {
      type: 'single',
      arguments: [
        {
          name: 'Total Quantity',
          type: 'label',
          value: _.get(processRow, 'quantity', ''),
          unit: 'KG',
          disabled: true
        }
      ]
    },
    tableHeaders: [{
      text: 'Waste %',
      value: 'wastePercentage'
    },
    {
      text: 'Waste',
      value: 'waste'
    }]
  }
}

export function convert(process: FTProcess) : ConversionResults {
  const conversionResult : ConversionResults = {
    inputs: [],
    outputs: [],
    details: new ConversionDetails(),
  };

  initProcess(process);

  conversionResult.outputs = process.outputs;
  const outputFTProcessRow = process.outputs[0];
  outputFTProcessRow.quantity = 0;
  _.map(process.inputs, (processInputRow: FTProcessRow, processInputKey : number) => {
    outputFTProcessRow.quantity += (processInputRow.quantity || 0);
    if (processInputKey == 0 && processInputRow.goodsObject) {
      outputFTProcessRow.goodsObject.copyFrom(processInputRow.goodsObject);
    } else {
      if(processInputRow.goodsType === 'packing-material') {
        const ratioWithoutPackingMaterial = (outputFTProcessRow.quantity - processInputRow.quantity) / outputFTProcessRow.quantity;
        const perKgRatio = _.get(outputFTProcessRow, 'goodsObject.perKgRatio.plA.value', false) || _.get(outputFTProcessRow, 'goodsObject.perKgRatio.plA.value', false) || 0;
        const value = ratioWithoutPackingMaterial * perKgRatio;
        outputFTProcessRow.goodsObject.setPerKgRatio('plA', value);
      }
    }
  })
  outputFTProcessRow.goodsObject.packingMode = _.get(process,'inputs.0.ftProcess.ftFactoryTicket.order.product.packingMode');
  conversionResult.details.wastePercentage = 0;
  conversionResult.details.waste = 0;
  conversionResult.details.netWeight = outputFTProcessRow.quantity;

  return conversionResult;
}